var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLessionsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0;}.b{fill:red;}.c{fill:#707070;}.d{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bb5cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b36fc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 60,
    height: 60
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1,1V59H59V1H1M0,0H60V60H0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M46.162,7.947a4.129,4.129,0,0,0,4.27-3.973,4.281,4.281,0,0,0-8.539,0A4.129,4.129,0,0,0,46.162,7.947Zm-.712,31.786v-10.6h1.423v10.6a2.854,2.854,0,0,0,5.693,0V15.893h12.1a2.75,2.75,0,0,0,2.846-2.649A2.75,2.75,0,0,0,64.664,10.6H63.241V5.3H80.319V21.191H63.241V18.542H57.548v3.973a4.13,4.13,0,0,0,4.27,3.973H81.742a4.13,4.13,0,0,0,4.27-3.973V3.973A4.13,4.13,0,0,0,81.742,0H61.817a4.13,4.13,0,0,0-4.27,3.973V10.6H44.837a8.7,8.7,0,0,0-7.32,3.857l-5.186,8.029a2.549,2.549,0,0,0,.97,3.634,2.972,2.972,0,0,0,3.9-.9l2.553-3.948V39.733a2.854,2.854,0,0,0,5.693,0Z",
    transform: "translate(-28.924 8.809)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessionsIcon);
export default __webpack_public_path__ + "static/media/lessionsIcon.17270c21209f692a6e8e7ab558071b7a.svg";
export { ForwardRef as ReactComponent };